// extracted by mini-css-extract-plugin
export var cardLayout = "_7u-1";
export var paginationContainer = "_7u-0";